import { Component, OnInit } from '@angular/core';
import { TCCPConstantValues } from '../../models/tccp-constants';
import { environment } from '../../../../environments/environment';
import { TCCPCommonService } from '../../services/tccp-common.service';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent implements OnInit {

  public appBase = TCCPConstantValues[environment.applicationName];
  public appName = '';
  constructor(public commonService: TCCPCommonService) { }

  ngOnInit() {
    this.appName = environment.applicationName;
  }

}
